import type { PaymentTermsKind } from '@/api';

/*
 * Условия оплаты клиента - наши поля у партнёра (в 1С условия по клиентам системно
 * не ведутся): вид и его параметр - процент частичной предоплаты или дни отсрочки.
 * Подписи общие у справочника клиентов и карточки отгрузки.
 */

export const PAYMENT_TERMS_KINDS: Record<PaymentTermsKind, string> = {
  Prepayment: 'Предоплата 100%',
  PartialPrepayment: 'Частичная предоплата',
  Deferred: 'Отсрочка платежа',
};

/** Все виды в порядке показа - для выбора. */
export const ALL_PAYMENT_TERMS_KINDS: ReadonlyArray<PaymentTermsKind> = [
  'Prepayment',
  'PartialPrepayment',
  'Deferred',
];

export interface PaymentTerms {
  paymentTerms?: PaymentTermsKind | null;
  prepaymentPercent?: number | string | null;
  paymentDeferralDays?: number | string | null;
}

/** Условия словами: «Частичная предоплата 50%», «Отсрочка 20 дн.»; null - не заданы. */
export const formatPaymentTerms = (terms: PaymentTerms): string | null => {
  switch (terms.paymentTerms) {
    case 'Prepayment':
      return PAYMENT_TERMS_KINDS.Prepayment;
    case 'PartialPrepayment':
      return `Частичная предоплата ${terms.prepaymentPercent ?? '?'}%`;
    case 'Deferred':
      return `Отсрочка платежа ${terms.paymentDeferralDays ?? '?'} дн.`;
    default:
      return null;
  }
};

/** Какая доля суммы - предоплата: 1 при 100%, процент при частичной, 0 при отсрочке; null - условия не заданы. */
export const resolvePrepaymentShare = (terms: PaymentTerms): number | null => {
  switch (terms.paymentTerms) {
    case 'Prepayment':
      return 1;
    case 'PartialPrepayment':
      return Number(terms.prepaymentPercent ?? 0) / 100;
    case 'Deferred':
      return 0;
    default:
      return null;
  }
};
